"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProductComparisonContext = _interopRequireDefault(require("./ProductComparisonContext"));

var KEY = 'cvo-eshop-compare-products';

var setLocalStorage = function setLocalStorage(v) {
  if (window && window.localStorage) {
    window.localStorage.setItem(KEY, JSON.stringify(v));
  }
};

function ProductComparisonProvider(_ref) {
  var children = _ref.children;

  var handlersRef = _react.default.useRef([]);

  var _React$useState = _react.default.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      comparedProducts = _React$useState2[0],
      setComparedProducts = _React$useState2[1];

  var resetComparedProducts = _react.default.useCallback(function () {
    setLocalStorage([]);
    setComparedProducts([]);
  }, [setComparedProducts]);

  var addProductToComparison = _react.default.useCallback(function (v) {
    return function () {
      setComparedProducts(function (p) {
        var id = v.id;
        var i = p.indexOf(id);
        var nextValue = i < 0 ? [].concat((0, _toConsumableArray2.default)(p), [id]) : p;
        setLocalStorage(nextValue);
        return nextValue;
      });
    };
  }, [setComparedProducts]);

  var removeProductFromComparison = _react.default.useCallback(function (v) {
    return function () {
      setComparedProducts(function (p) {
        var i = p.indexOf(v.id);
        var nextValue = i >= 0 ? [].concat((0, _toConsumableArray2.default)(p.slice(0, i)), (0, _toConsumableArray2.default)(p.slice(i + 1))) : p;
        setLocalStorage(nextValue);
        return nextValue;
      });
    };
  }, [setComparedProducts]);

  _react.default.useEffect(function () {
    handlersRef.current.forEach(function (h) {
      return h(comparedProducts);
    });
  }, [comparedProducts]);

  _react.default.useEffect(function () {
    var products = window && window.localStorage && function (x) {
      return x ? JSON.parse(x) : undefined;
    }(window.localStorage.getItem(KEY));

    if (products && products.length > 0) {
      setComparedProducts(products);
    }
  }, [setComparedProducts]);

  return /*#__PURE__*/_react.default.createElement(_ProductComparisonContext.default.Provider, {
    value: {
      comparedProducts: comparedProducts,
      resetComparedProducts: resetComparedProducts,
      addProductToComparison: addProductToComparison,
      removeProductFromComparison: removeProductFromComparison,
      addChangeEventListener: function addChangeEventListener(h) {
        handlersRef.current = [].concat((0, _toConsumableArray2.default)(handlersRef.current || []), [h]);
      },
      removeChangeEventListener: function removeChangeEventListener(h) {
        var i = handlersRef.current.findIndex(function (x) {
          return x === h;
        });

        if (i > -1) {
          handlersRef.current = [].concat((0, _toConsumableArray2.default)(handlersRef.current.slice(0, i)), (0, _toConsumableArray2.default)(handlersRef.current.slice(i + 1)));
        }
      }
    }
  }, children);
}

process.env.NODE_ENV !== "production" ? ProductComparisonProvider.propTypes = {
  children: _propTypes.default.node
} : void 0;
ProductComparisonProvider.defaultProps = {
  children: null
};
var _default = ProductComparisonProvider;
exports.default = _default;